import Component from '../core/Component'

export const STATES = {
    ACTIVE: 'is-active',
    VIEWPORT: 'in-viewport',
    FADEIN: 'fade-in',
    FADEOUT: 'fade-out',
    MOBILE_BREAKPOINT: 767,
}

export default class FixedMultiAlerts extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            links: [],
            messages: [],
            alerts: [],
            alertsCount: null,
            selectedId: null,
            isHovered: false,
            content: null,
            isOpen: false,
            close: null,
            overlay: null
        }
    }

    prepare() {
        this.ref.close.addEventListener('click', this.handleClickClose)
        this.ref.overlay.addEventListener('click', this.handleClickOverlay)
        this.ref.links.forEach(link => link.addEventListener('click', this.handleClickLink))
        this.ref.alerts.forEach(button => {
            button.addEventListener('click', this.handleClickAlert)
            button.addEventListener('mouseout', this.handleMouseoutAlert)
            button.addEventListener('mouseover', this.handleMouseoverAlert)
        })

        this.selectedId = this.ref.alerts[0].getAttribute("data-id")
        this.alertsCount = this.ref.alerts.length

        if(this.alertsCount > 1){
            this.startTimer(this)
        }

        if (this.element.classList.contains('is-active')) {
            document.documentElement.classList.add('has-fixedmultialerts')
        }
    }

    

    handleClickAlert = event => {
        if(event.target.classList.contains(STATES.ACTIVE)){
            event.target.classList.remove(STATES.ACTIVE)
            event.target.classList.add(STATES.VIEWPORT)

            this.contentControl(false)

        } else {
            this.refreshMessages()
            this.selectMessage(this.selectedId)

            this.contentControl(true)
        }
    }

    handleMouseoverAlert = event => {
        if(window.innerWidth > STATES.MOBILE_BREAKPOINT){
            this.isHovered = true
        } else {
            this.isHovered = false
        }
    }

    handleMouseoutAlert = event => {
        this.isHovered = false
    }

    handleClickLink = event => {
        this.showAlert(null, event.target.getAttribute("data-id"))

        this.refreshMessages()
        this.selectMessage(this.selectedId)
    }

    handleClickOverlay = event => {
        this.ref.alerts.forEach(alert => alert.classList.remove(STATES.ACTIVE))
        this.refreshMessages()
        this.contentControl(false)
    }

    handleClickClose = event => {
        this.close()
    }

    startTimer(item) {
        let loop = setInterval(execute, 2000)

        function execute() {
            item.tick()
        }
    }

    selectMessage(id) {
        this.ref.links.forEach(item => this.checkIfActive(item, id))
        this.ref.alerts.forEach(item => this.checkIfActive(item, id))
        this.ref.messages.forEach(item => this.checkIfActive(item, id))
    }

    tick() {
        if(!this.isOpen && !this.isHovered){
            this.showNextAlert()
        }
    }

    showNextAlert() {
        let nextAlertPosition = this.getIdPosition() + 1

        if(nextAlertPosition >= this.alertsCount){
            this.showAlert(0, null)
        }else{
            this.showAlert(nextAlertPosition, null)
        }
    }

    getIdPosition(id) {
        let position = 0
        let target = 0

        if(id){
            target = id
        } else {
            target = this.selectedId
        }
        
        this.ref.alerts.some((alert) => {
            if (target === alert.getAttribute("data-id")) {
                return true;
            }
            position++

            return false
        })

        return position
    }

    contentControl(requestedState) {
        this.isOpen = requestedState

        if(requestedState){
            this.ref.content.classList.add(STATES.ACTIVE)
            this.ref.overlay.classList.add(STATES.ACTIVE)
        } else {
            this.ref.content.classList.remove(STATES.ACTIVE)
            this.ref.overlay.classList.remove(STATES.ACTIVE)
        }
    }

    showAlert(position, id) {
        this.ref.alerts.some((alert) => {
            if (this.selectedId === alert.getAttribute("data-id")) {
                alert.classList.remove(STATES.FADEIN, STATES.VIEWPORT, STATES.ACTIVE)
                alert.classList.add(STATES.FADEOUT)
                return true;
            }
            return false
        })

        if(id){
            this.selectedId = id
            this.ref.alerts[this.getIdPosition()].classList.remove(STATES.FADEOUT)
            this.ref.alerts[this.getIdPosition()].classList.add(STATES.FADEIN, STATES.VIEWPORT)
        } else {
            this.selectedId = this.ref.alerts[position].getAttribute("data-id")
            this.ref.alerts[position].classList.remove(STATES.FADEOUT)
            this.ref.alerts[position].classList.add(STATES.FADEIN, STATES.VIEWPORT)
        }
    }

    clearAlerts() {
        this.ref.alerts.forEach(alert => this.clearAlert(alert))
    }

    clearAlert(alert) {
        if(alert.classList.contains(STATES.VIEWPORT) && alert.classList.contains(STATES.FADEOUT)){
            alert.classList.remove(STATES.VIEWPORT, STATES.FADEOUT)
        }
    }

    checkIfActive(item, id) {
        if(id === item.getAttribute("data-id")){
            item.classList.add(STATES.ACTIVE)

            return
        }
    }

    refreshMessages() {
        this.ref.links.forEach(link => link.classList.remove(STATES.ACTIVE))
        this.ref.messages.forEach(message => message.classList.remove(STATES.ACTIVE))
    }

    close() {
        this.element.classList.remove(STATES.ACTIVE)
        document.documentElement.classList.remove('has-fixedmultialerts')
    }
}